<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import Button from 'dashboard/components-next/button/Button.vue';
const props = defineProps({ groupTitle: { type: String, required: true }, mode: { type: String, default: 'off' },
  disabled: Boolean, ready: Boolean, managementReady: Boolean, saving: Boolean });
const emit = defineEmits(['change', 'info']);
function change(event) {
  const value = event.target.value;
  event.target.value = props.mode;
  emit('change', value);
}
</script>

<template>
  <div class="flex max-w-full items-center gap-1">
  <div class="relative w-36 max-w-full">
  <select :value="mode" :disabled="disabled || saving" :aria-busy="saving" :aria-label="`Режим группы ${groupTitle}`" aria-describedby="tg-group-mode-help" @change="change"
    class="m-0 w-full appearance-none rounded-lg border border-n-weak bg-n-alpha-2 bg-none py-2 pl-3 pr-8 text-sm text-n-slate-12 focus:outline-none focus:ring-1 focus:ring-n-brand">
    <option value="off">Выключен</option>
    <option value="observe" :disabled="!ready">Наблюдение</option>
    <option v-if="managementReady" value="manage" :disabled="!ready">Управление</option>
  </select>
  <span class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-n-slate-11" aria-hidden="true"><Icon :icon="saving ? 'i-lucide-loader-circle' : 'i-lucide-chevron-down'" class="size-3.5" :class="{ 'animate-spin': saving }" /></span>
  </div>
  <Button type="button" icon="i-lucide-info" slate ghost size="sm" class="min-h-10 min-w-10" :aria-label="`О режиме: ${groupTitle}`" title="Возможности режима" @click="emit('info')" />
  </div>
</template>
